import React from "react";

import { Progress } from "../ui/progress";

import { CustomToolTip } from "./CustomToolTip";

type ProgressLabelProps = {
  label: string;
  value: number;
  color: string;
  tooltip?: {
    toolTipContent: React.ReactNode;
    handleClick?: () => void;
  };
};

const ProgressLabel = ({
  label,
  value,
  color,
  tooltip,
}: ProgressLabelProps): React.JSX.Element => {
  const progress = (
    <div className='text-gray-700 dark:text-white'>
      <div className='flex justify-between mb-2 text-xs font-mediums'>
        <span>{label}</span>
      </div>
      <Progress
        segments={[
          {
            value,
            color,
          },
        ]}
      />
    </div>
  );

  const renderComponent = tooltip?.toolTipContent ? (
    <CustomToolTip
      toolTipTrigger={progress}
      toolTipContent={tooltip?.toolTipContent}
      handleClick={tooltip?.handleClick}
    />
  ) : (
    progress
  );

  return renderComponent;
};

export default ProgressLabel;
